import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {State} from '@progress/kendo-data-query';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {UserContext} from '../services/user-context';
import {ApiService} from '../services/api';
import {ProfileDialogComponent} from './profile-dialog.component';
import {PasswordDialogComponent} from './password-dialog.component';
import {
  EventClickEvent,
  SchedulerComponent,
  SchedulerEvent,
  SlotClickEvent
} from '@progress/kendo-angular-scheduler';
import * as moment from 'moment-timezone';
import * as uuidv4 from 'uuid/v4';
import {IntlService} from '@progress/kendo-angular-intl';
import '@progress/kendo-date-math/tz/America/New_York';
import {BehaviorSubject, Subject} from 'rxjs';
import {AvailabilityDialogComponent} from './availability-dialog.component';
import {HttpParams} from '@angular/common/http';
import {BankAccountComponent} from '../bank/bank-account.component';
@Component({
  selector: 'app-profile',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'profile.template.html',
  styleUrls: [
    './profile.style.scss'
  ]
})
export class ProfileComponent implements OnInit, OnDestroy {
  @ViewChild('scheduler', {static: true}) scheduler: SchedulerComponent;

  public sessionsState: State = {
    skip: 0,
    take: 5
  };

  public user: any;

  updated = false;
  schedulerDate = new Date();
  schedule:SchedulerEvent[] = [];
  connectAccountTypes: Array<any> = [{
    text: 'Register as an individual',
    type: "individual"
  }, {
    text: 'Register as a business',
    type: 'company'
  }];

  constructor(private route: ActivatedRoute,
              public dialog: MatDialog,
              private matIconRegistry: MatIconRegistry,
              private domSanitizer: DomSanitizer,
              private changeDetectRef: ChangeDetectorRef,
              private userContext: UserContext,
              private snackBar: MatSnackBar,
              private intlService: IntlService,
              private api: ApiService) {
  }


  public ngOnInit(): void {
    this.refresh();
  }

  public refresh(): void {
    this.api.get<any>(`/user/${this.userContext.user.reference}`)
      .subscribe(result => {
        this.user = result;

        this.resetSchedule();
      }, (error) => {
        console.log('Found error ' + JSON.stringify(error));
      });
  }

  public manageBankAccounts():void {
    const dialogRef = this.dialog.open(BankAccountComponent, {
      width: '700px',
      data:{mode:'user'}
    });

    dialogRef.afterClosed().subscribe(external_account => {
    });
  }

  public requiresExternalAccount():boolean {
    return this.user.connect_id && (this.user.connect_requirements.currently_due || []).includes("external_account");
  }

  public connectAccount(type:any): void {
    this.api.post<any>(`/user/${this.userContext.user.reference}/connect`,{type:type.type})
      .subscribe(result => {
        this.user = result;
        if( this.user.connect_id ) {
          this.verifyConnectAccount();
        }
      }, (error) => {
        console.log('Found error ' + JSON.stringify(error));
      });
  }

  public verifyConnectAccount(): void {
    this.api.get<any>(`/user/${this.userContext.user.reference}/connect/verify`)
      .subscribe(result => {
        console.log("Received connect: " + JSON.stringify(result));
        if( result.url ) {
          window.location = result.url;
        }
      });
  }

  public updateConnectAccount(): void {
    this.api.get<any>(`/user/${this.userContext.user.reference}/connect/update`)
      .subscribe(result => {
        console.log("Received connect: " + JSON.stringify(result));
        if( result.url ) {
          window.location = result.url;
        }
      });
  }

  public ngOnDestroy(): void {
  }

  public ngAfterViewInit(): void {

  }

  public doubleClickedSlot(event): void {

  }

  public doubleClickedEvent(event:EventClickEvent): void {
    this.schedule = this.schedule.filter(e => e.recurrenceId === event.event.recurrenceId);
    //console.log("Removing " + JSON.stringify(event.event));
  }

  public clickedSlot(event:SlotClickEvent): void {
    console.log("Click started...");
    let availabilitySlot = {
      title: "Available",
      dataItem: {type: "telehealth"},
      startTimezone: this.user.timezone || moment.tz.guess(),
      start: event.start,
      endTimezone: this.user.timezone || moment.tz.guess(),
      end: event.end,
      id: uuidv4(),
      recurrenceRule: "FREQ=WEEKLY"
    } as SchedulerEvent;

    const dialogRef = this.dialog.open(AvailabilityDialogComponent, {
      width: '400px',
      data: availabilitySlot
    });

    dialogRef.afterClosed().subscribe(slot => {
      if( slot ) {
        if (slot.dataItem.type === 'telehealth') {
          slot.title = "Telehealth";
        } else {
          slot.title = "Available";
        }
        this.schedule = [...this.schedule].concat([slot]);
        this.updated = true;
      }
    });
  }

  public clickedEvent(event): void {
    console.log("Click event started...");
  }

  public updateScheduleForMode() {
  }

  public resetSchedule() {
    this.schedule = (this.user.schedule || []).map( s => { return {
      title: s.type === 'telehealth' ? 'Telehealth' : 'Available',
      type: s.type,
      startTimezone: this.user.timezone || moment.tz.guess(),
      start: this.intlService.parseDate(`${s.start}`),
      endTimezone: this.user.timezone || moment.tz.guess(),
      end: this.intlService.parseDate(`${s.end}`),
      id: s.id,
      recurrenceRule: s.recurring ? "FREQ=WEEKLY" : null
    } as SchedulerEvent; });
  }

  public updateAvailability() {
    if ( this.updated ) {
      console.log("Updating with: " + JSON.stringify(this.schedule));
      this.user.schedule = this.schedule.map( s => { return {
        type: s.title === 'Telehealth' ? 'telehealth' : 'office',
        start: s.start.toISOString(),
        end: s.end.toISOString(),
        recurring: s.recurrenceRule === "FREQ=WEEKLY",
        id: s.id
      }});
      console.log("Updated with: " + JSON.stringify(this.user.schedule));

      this.api.patch<any>(`/user/${this.userContext.user.reference}`, {
        schedule: this.user.schedule
      }).subscribe( result => {
        console.log("Updated user respoonse: " + JSON.stringify(result));
        this.user = result;
        this.resetSchedule();
        this.updated = false;
        this.snackBar.open('Availability updated.', null, {
          duration: 2000
        });
      }, (error) => {
        this.snackBar.open(`Error updating availability: ${error}`, null, {
          duration: 2000
        });
      });
    }
  }

  public editProfile(): void {
    const dialogRef = this.dialog.open(ProfileDialogComponent, {
      width: '750px',
      data: this.user
    });

    dialogRef.afterClosed().subscribe(user => {
      if ( user ) {
        this.api.patch<any>(`/user/${this.userContext.user.reference}`, {
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          titles: this.user.titles,
          email: this.user.email,
          picture: this.user.picture,
          country: this.user.country,
          phone: this.user.phone
        }).subscribe( result => {
          console.log("Updated user respoonse: " + JSON.stringify(result));
          this.user = result;
          this.snackBar.open('Profile updated.', null, {
            duration: 2000
          });
        }, (error) => {
          this.snackBar.open(`Error updating profile: ${error}`, null, {
            duration: 2000
          });
        });
      }
    });
  }

  public changePassword(): void {
    const dialogRef = this.dialog.open(PasswordDialogComponent, {
      width: '350px',
      data: this.user
    });

    dialogRef.afterClosed().subscribe(user => {
      if ( user ) {
        this.api.patch<any>(`/user/${this.userContext.user.reference}`, user).subscribe( result => {
          console.log("Updated password: " + JSON.stringify(result));
          this.user = result;
          this.snackBar.open('Password changed.', null, {
            duration: 2000
          });
        }, (error) => {
          this.snackBar.open(`Error changing password: ${error}`, null, {
            duration: 2000
          });
        });
      }
    });
  }

}
